import { useState } from 'react';

// The Phase 3 schedule form (recruiter, company admin, master admin): when the chosen job is HM-created and its hiring
// manager set the Quali5d technical screen on field 18, its length and type are filled in and shown read-only
// ("Set by hiring manager"). Older jobs (no values) keep today's behaviour — the recruiter chooses. The values are the
// existing Phase 3 ones (duration_minutes 45 / 60 / 75, coding_mode verbal_pseudocode | live_coding).
export function useJobTechScreen(setInterviewDuration, setCodingMode) {
  const [fromJob, setFromJob] = useState(false);
  const apply = (ts) => {
    if (ts && ts.duration_minutes && ts.coding_mode) {
      setInterviewDuration(ts.duration_minutes);
      setCodingMode(ts.coding_mode);
      setFromJob(true);
    } else {
      setFromJob(false);
    }
  };
  return [fromJob, apply, () => setFromJob(false)];
}
